import { Bank } from '@/manager/payment/models/bank.model';

export interface BankAccountInterface {
    id?: string;
    number?: string;
    holder?: string;
    bank?: Bank;
}

export class BankAccount implements BankAccountInterface {
    public id?: string;
    public number?: string;
    public bank?: Bank;
}
